import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import {
  BuildingFilterDto,
  MaintenanceTimerService,
  MaintenanceTimerStatisticsFilterDto, TenantItemDto,
} from '@artemis-software/wr-api';
import { FormBuilder, FormGroup } from '@angular/forms';
import { loader } from '@/utils/signals/loader';
import { asyncComputed } from '@/utils/signals/asyncComputed';

@Component({
  standalone: false,
  selector: 'wr-maintenance-timer-statistics-page',
  templateUrl: './maintenance-timer-statistics-page.component.html',
  styleUrls: ['./maintenance-timer-statistics-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaintenanceTimerStatisticsPageComponent {

  readonly isLoading = loader();

  readonly filter: WritableSignal<MaintenanceTimerStatisticsFilterDto> = signal({
    buildingIds: undefined, // TODO: change building id based on selected building
    tenantId: undefined,
  });

  readonly statistics = asyncComputed(
    () => {
      const filter = this.filter();
      return this.maintenanceTimerService.getStatistics({
        buildingId: filter.buildingId,
        tenantId: filter.tenantId,
      });
    },
    undefined,
    this.isLoading,
  );

  form!: FormGroup;

  constructor(
    private readonly maintenanceTimerService: MaintenanceTimerService,
    private readonly formBuilder: FormBuilder,
  ) {
    this.form = new FormGroup({
      tenantId: this.formBuilder.control(undefined),
      buildingId: this.formBuilder.control(undefined),
      building: this.formBuilder.control(undefined),
    });

    this.form.controls['building'].valueChanges.subscribe((value) => {
      this.form.controls['buildingId'].setValue(value?.id);
    });
    this.form.controls['tenantId'].valueChanges.subscribe((value) => {
      this.form.controls['building'].setValue(undefined);
    });
  }

  triggerFilter(): void {
    const formValue = this.form.value;
    this.filter.set({
      tenantId: formValue.tenantId,
      buildingId: formValue.buildingId,
    });
  }

  maintenanceTimerData() {
    return [
      {
        data: [this.statistics()?.overdueMaintenances ?? 0, 0, 0],
        label: this.maintenanceTimerLabels()[0],
        backgroundColor: '#ffc94d',
      },
      {
        data: [0, this.statistics()?.completedOnTimeMaintenances ?? 0, 0],
        label: this.maintenanceTimerLabels()[1],
        backgroundColor: '#00b887',
      },
      {
        data: [0, 0, this.statistics()?.completedNotOnTimeMaintenances ?? 0, 0],
        label: this.maintenanceTimerLabels()[2],
        backgroundColor: '#ff3d71',
      },
      {
        data: [0, 0, 0, this.statistics()?.totalMaintenanceTimers ?? 0],
        label: this.maintenanceTimerLabels()[3],
        backgroundColor: '#0095ff',
      },
    ];
  }

  maintenanceTimerLabels() {
    return ['überfällige Wartungen', 'pünktlich Abgeschlossene Wartungen', 'nicht Pünktlich Abgeschlossene Wartungen', 'gesamt Wartungstimer'];
  }

  protected readonly BuildingFilterDto = BuildingFilterDto;
  protected readonly TenantTypeEnum = TenantItemDto.TypeEnum;
}
